import { createLoadableComponent } from '../../infrastructure/code-splitting/utils/LoadableComponentFactory';

export default createLoadableComponent(
  () => import('./containers/BookingStepPageGraphqlContainer'),
);
